<template>
  <b-overlay :show="loading" :opacity="1">
    <div id="accommodations-list" class="mt-4">
      <b-row>
        <b-col
          v-for="accommodation in currentAccommodations"
          :key="`accommodation-${accommodation.uuid}`"
          cols="12"
          sm="6"
          lg="3"
        >
          <accommodation-card :accommodation="accommodation" />
        </b-col>
        <b-col v-if="!loading && !currentAccommodations.length" cols="12">
          <b-card id="no-accommodations-card" class="text-center py-5">
            <feather-icon icon="HomeIcon" size="48" class="text-secondary mb-3" />
            <h4 class="mb-0">
              {{ $t("pages.accommodationsList.noAccommodations") }}
            </h4>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </b-overlay>
</template>

<script>
import { BOverlay, BRow, BCol, BCard } from "bootstrap-vue";
import FeatherIcon from "@core/components/feather-icon/FeatherIcon.vue";
import AccommodationCard from "@/views/accommodations/list/components/AccommodationCard.vue";

export default {
  components: {
    BOverlay,
    BRow,
    BCol,
    BCard,
    FeatherIcon,
    AccommodationCard,
  },
  computed: {
    loading() {
      return this.$store.getters["accommodations/loading"];
    },
    currentAccommodations() {
      return this.$store.getters["accommodations/accommodations"];
    },
  },
  created() {
    if (!this.loading && !this.currentAccommodations.length) {
      this.$store.dispatch("accommodations/fetchAccommodations");
    }
  },
};
</script>

<style lang="scss">
#accommodations-list {
  min-height: 100px;
}
</style>
